/**
 * @generated SignedSource<<3d570c7dd5017bef85fbe171161a3082>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SprintDropdown_sprints$data = ReadonlyArray<{
  readonly node: {
    readonly name: string | null;
    readonly id: string;
    readonly projectGroupSprintId: string | null;
    readonly isProjectGroupSprint: boolean | null;
    readonly endYear: number | null;
    readonly endMonth: number | null;
    readonly endDay: number | null;
  } | null;
  readonly " $fragmentType": "SprintDropdown_sprints";
}>;
export type SprintDropdown_sprints$key = ReadonlyArray<{
  readonly " $data"?: SprintDropdown_sprints$data;
  readonly " $fragmentSpreads": FragmentRefs<"SprintDropdown_sprints">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "SprintDropdown_sprints",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Sprint",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectGroupSprintId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isProjectGroupSprint",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endYear",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endMonth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endDay",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SprintTypeEdge",
  "abstractKey": null
};

(node as any).hash = "792a58f5b868b02a831547b6305a099f";

export default node;
